import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { environment } from 'src/environments/environment';
import { xml2json } from "xml-js";

@Component({
  selector: 'app-session-list',
  templateUrl: './session-list.component.html',
  styleUrls: ['./session-list.component.css']
})
export class SessionListComponent implements OnInit {

  Sessions = [];
  errors = new Array();
  errObject: any;
  param: any;
  iframe: any;

  dataSource = new MatTableDataSource();

  displayedColumns: string[] = [
    "sessionDatePersian",
    "sessionTime",
    "adobeConnect"
  ];
  constructor(
    private courseService: CourseService,
    private curDialog: MatDialogRef<SessionListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.getCourseSession();
  }

  getCourseSession() {

    this.dataSource = null;
    this.courseService.getCourseSession(this.data.CourseId).subscribe(result => {
      this.dataSource = result.map((item) => {
        return {
          SessionDatePersian: item.SessionDatePersian,
          StartTime: item.StartTime,
          EndTime: item.EndTime,
          AdobeConnectScoId: item.AdobeConnectScoId,
          AdobeConnectUrlPath: item.AdobeConnectUrlPath,
          BaseVirtualClassUrl: item.BaseVirtualClassUrl,
          SessionArchive: item.SessionArchive ? JSON.parse(xml2json(item.SessionArchive, { compact: true, spaces: 4 })) : null,
        }
      })
    })
  }

  loginToVirtualClass(url: string) {
    const win = window.open(
      environment.AdobeConnect + "/api/xml?action=login&login=" + JSON.parse(window.localStorage.getItem('userInfo')).NationalCode + "&password=" + JSON.parse(window.localStorage.getItem('userInfo')).NationalCode,
      'Adobe Connect');
    setTimeout(function () {
      win.location.href = url;
    }, 1)
  }

  onNoClick() {
    this.curDialog.close();
  }

}
